import { useQuery } from "@tanstack/react-query";
import type {
	QuestionsFilters,
	SearchCounts,
	SearchQuestion,
} from "src/api/search";
import { searchQuestions } from "src/api/search";
import { queryClient } from "src/queryClient";
import newApi, { buildQuery } from "src/newApi";

import options from "./defaultOptions";

type QuestionsResult = {
	count: number;
	results: SearchQuestion[];
	counts?: SearchCounts;
};

// null = filtry jeszcze nie gotowe; klucz z buildQuery, żeby doczytanie nazw (terminy, konsultanci) nie robiło refetchu
export function useQuestions(filters: QuestionsFilters | null, page: number) {
	return useQuery<QuestionsResult>({
		queryKey: [
			"questions",
			page,
			filters && buildQuery(filters),
			filters?.commentsNotifications,
		],

		queryFn: async () => {
			const { count, items, counts } = await searchQuestions(filters ?? {}, {
				page,
			});

			return { count, results: items, counts };
		},

		...options,
		enabled: !!filters,
	});
}

export function useQuestion(id: number | string) {
	return useQuery<SearchQuestion | undefined>({
		queryKey: ["question", id],

		queryFn: async () => {
			const { items } = await searchQuestions(
				{ questions: [id] },
				{ page: 0, take: 1 },
			);

			return items[0];
		},

		...options,
	});
}

export async function refetchQuestions() {
	await queryClient.refetchQueries({ queryKey: ["questions"] });
}

type ExamDetails = Record<string, unknown> & {
	questionsPerDay?: unknown;
	endDate?: unknown;
	shuffle?: { checked?: boolean; questions?: number };
};

export function useGetCountOfQuestions({
	questionsPerDay,
	endDate,
	shuffle,
	...details
}: ExamDetails) {
	return useQuery({
		queryKey: ["countOfQuestions", details],

		queryFn: async () => {
			return newApi.getCount(details);
		},

		...options,
		enabled: !!details,
	});
}

export function useGetExamPreviewDetails({
	questionsPerDay,
	endDate,
	shuffle,
	...details
}: ExamDetails) {
	return useQuery({
		queryKey: ["examPreviewDetails", details, shuffle],

		queryFn: async () => {
			return newApi.getExamPreviewDetails({
				...details,
				shuffleCount: shuffle?.checked ? shuffle.questions : undefined,
				createdAt: new Date(),
			});
		},

		...options,
		enabled: !!details,
	});
}
